module.exports = __webpack_public_path__ + "static/img/图层 545.0880776e.png";